import './Navbar.css';
import logoED from '../assets/logo.png';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img src={logoED} alt="Logo Emilse Diaz" className="navbar-logo-img" />
        <span className="navbar-name">Emilse Diaz</span>
      </div>
      <div className="navbar-links">
        <a href="#sobre-mi">Sobre mí</a>
        <a href="#habilidades">Habilidades</a>
        <a href="#proyectos">Proyectos</a>
        <a href="#contacto">Contacto</a>
      </div>
    </nav>
  );
};

export default Navbar;
